<template>
  <v-container fluid>
    <v-text-field
      v-model="search"
      append-icon="mdi-database-search"
      label="Buscar"
    >
    </v-text-field>
    <v-form ref="formTableValidate">
      <v-data-table
        width="100%"
        dense
        :headers="headers"
        :items="entrys"
        :no-data-text="$t('jefecomunidad.entrysTable.empty')"
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-page-first',
          lastIcon: 'mdi-page-last',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
        }"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        item-key="dts_persona.id"
        show-expand
      >
        <v-progress-linear
          slot="progress"
          indeterminate
          color="blue lighten-2"
        >
        </v-progress-linear>
        <!--<template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-switch
              v-model="singleExpand"
              label="Expansión individual"
              class="mt-2"
            >
            </v-switch>
          </v-toolbar>
        </template>-->
        <template v-slot:item.dts_persona.cilindros="{ item }">
          <v-chip :color="getColor(item.dts_persona.cilindros)" dark>
            {{ item.dts_persona.cilindros }}
          </v-chip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-divider></v-divider>
            <h4 class="mt-4 mb-4"><v-icon right>mdi-beaker-outline</v-icon> Cilindros Registrados</h4>
            <v-divider></v-divider>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">MARCA</th>
                    <th class="text-center">PESO</th>
                    <th class="text-center">CANTIDAD</th>
                    <th class="text-center">VENTA RESTRINGIDA</th>
                    <th class="text-center">DIAS BLOQUEADOS</th>
                    <th class="text-center">FECHA COMPRA / PROXIMA VENTA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="dts_bombonas_hogar in item.dts_bombonas_hogars"
                    :key="'table-jc-in-modal-' + dts_bombonas_hogar.id"
                  >
                    <td>{{ dts_bombonas_hogar.dts_bombona.nombre }}</td>
                    <td class="text-center">
                      {{ dts_bombonas_hogar.tps_bombonas.peso }}
                    </td>
                    <td class="text-center" style="width: 15em;">
                      <p v-if="detail && detail.cilindros_cantidad_tps_bombonas">
                        {{ detail.cilindros_cantidad_tps_bombonas[dts_bombonas_hogar.dts_persona][dts_bombonas_hogar.tps_bombonas.id] }}
                      </p>
                      <v-select
                        v-else
                        v-model="dts_bombonas_hogar.cantidad_pedido"
                        item-text="nombre"
                        item-value="id"
                        :items="getCantidadOption(dts_bombonas_hogar.cant_bombona)"
                        label="SELECCIONAR"
                        @change="activeValidation"
                        :disabled="isLocked(dts_bombonas_hogar.proxima_venta, dts_bombonas_hogar.fecha_venta, dts_bombonas_hogar.tps_bombonas.frecuencia)"
                      >
                      </v-select>
                    </td>
                    <td class="text-center">
                      
                      <v-chip
                        v-if="isLocked(dts_bombonas_hogar.proxima_venta, dts_bombonas_hogar.fecha_venta, dts_bombonas_hogar.tps_bombonas.frecuencia)"
                        color="red"
                        text-color="white"
                      >
                     Inactivo
                      </v-chip>
                      <v-chip
                        v-else
                        color="green"
                        text-color="white"
                      >activo</v-chip>
                    </td>
                    <td class="text-center">
                      <span v-if="getDuration(dts_bombonas_hogar.proxima_venta) < 0">{{ 0 }}</span>
                      <span v-else>{{ getDuration(dts_bombonas_hogar.proxima_venta) || 0 }}</span>
                    </td>
                    <td class="text-center">
                      {{ getDateVentas(dts_bombonas_hogar.fecha_venta, dts_bombonas_hogar.proxima_venta) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </template>
      </v-data-table>
    </v-form>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
import messageMixin from "@/mixins/common"
import moment from "moment"

export default {
  name: "jefes-hogar-table",
  mixins: [messageMixin],
  props: {
    entrys: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      expanded: [],
      singleExpand: false,
      headers: [
        {
          text: "NÚMERO DE CÉDULA",
          value: "dts_persona.cedulas",
          align: "center",
        },
        {
          text: "NOMBRES",
          value: "dts_persona.nombres",
          align: "left",
        },
        {
          text: "APELLIDOS",
          value: "dts_persona.apellidos",
          align: "left",
        },
        {
          text: this.$t("contacto.n_tlf_casa"),
          value: "dts_persona.telefonos",
          align: "left",
        },
        {
          text: this.$t("habitante.sexo"),
          value: "dts_persona.tps_sexo.nombre",
          align: "left",
        },
        {
          text: "CALLE",
          value: "dts_direccion.calle",
          align: "left",
        },
        {
          text: "CASA",
          value: "dts_direccion.casa",
          align: "center",
        },
        {
          text: "CILINDROS",
          value: "dts_persona.cilindros",
          align: "center",
        },
      ],
      search: "",
    }
  },
  computed: {
    ...mapState("Pedidos", ["detail"]),
  },
  methods: {
    getColor(cilindros) {
      if (cilindros > 10) return "red"
      if (cilindros > 5) return "orange"
      return "green"
    },
    getCantidadOption(total) {
      const options = []
      for (let i = 0; i <= total; i++) {
        options.push({
          id: i,
          nombre: i,
        })
      }

      return options
    },
    activeValidation() {
      this.$emit('calculateCilindro');
      this.$refs.formTableValidate.validate();
    },

    getDuration(fecha) {
      let proxima_venta = moment(fecha);
      let fecha_today = moment();
      let duration = proxima_venta.diff(fecha_today, 'days');

      return duration;
    },

    // Se verifica si la persona se le puede vender cilindro segun los kg
    isLocked(fecha, fecha_v, frecuencia) {

      if (fecha !== null ) {
       
        // Dias para desbloqueo 50%
        let dias = parseInt(frecuencia / 2);

        //Fecha Actual

        let fecha_actual = moment();

        let proxima_venta = moment(fecha);
        let fecha_venta = moment(fecha_v);
        
        // Dias Faltante para la proxima venta
        let durations = proxima_venta.diff(fecha_venta, 'days');

        let d = proxima_venta.diff(fecha_actual, 'days');

        
        if ( d < 15) {
          //alert(' d ' + d + ' dias' + dias + 'durations ' + durations);
          return false;
        } 
        return true;
      }
      
      return false;
      
    },

    getDateVentas(fecha_venta, proxima_venta) {
      if ( fecha_venta === null || proxima_venta === null) {
        return '';
      }

      return fecha_venta + ' - ' + proxima_venta;
    }

  },
}
</script>
